import { Colors, Fonts } from '../../../../shared/theme';
import React from 'react';

export default {
  tablesContent: {
    backgroundColor: Colors.white,
    padding: 20,
    marginBottom: '20px'
  } as React.CSSProperties,
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: '20px',
    height: '56px'
  } as React.CSSProperties,
  remarkText: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text12,
    color: Colors.font.primary.darkGray,
  },
  paddingTop20: {
    paddingTop: '20px',
  },
  paddingTop30: {
    paddingTop: '30px',
  },
  width240: {
    width: '240px'
  },
  paddingBottom4: {
    paddingBottom: '4px',
    display: 'flex'
  },
  tagVerified: {
    color: Colors.tagGreen,
    background: Colors.tagPalegreen,
    border: '1px solid',
    borderColor: Colors.tagLightgreen
  },
  tagPending: {
    color: Colors.tagYellow,
    background: Colors.tagPaleyellow,
    border: '1px solid',
    borderColor: Colors.tagLightyellow
  },
  tagExpired: {
    color: Colors.tagRed,
    background: Colors.tagPalered,
    border: '1px solid',
    borderColor: Colors.tagLightred
  },
  previousEmailCc: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text12,
    color: Colors.font.primary.darkGray,
  },
  emailTo: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text12,
    color: Colors.font.primary.fakeBlack,
    paddingLeft: '30px',
  },
  emailToIsExpired: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text12,
    color: Colors.font.messaging.errorRed,
    paddingLeft: '30px',
  },
  emailCc: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text12,
    color: Colors.font.primary.fakeBlack,
    paddingLeft: '28px',
  },
  emailCcIsExpired: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text12,
    color: Colors.font.messaging.errorRed,
    paddingLeft: '28px',
  },
  regularPurple12underline: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text12,
    textDecoration: 'underline',
    color: Colors.lightPurple,
    cursor: 'pointer',
    paddingTop: '3px'
  },
  regular16FakeBlack: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text16,
    color: Colors.font.primary.fakeBlack,
  },
  regular14DarkGray: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text14,
    color: Colors.font.primary.darkGray,
  },
  regular12DarkGray: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text12,
    color: Colors.font.primary.darkGray,
  },
  regular12Gray: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text12,
    color: Colors.font.primary.gray,
  },
  mailIcon: {
    color: Colors.font.primary.fakeBlack,
    width: '40px',
    height: '31.43px',
    fontSize: '40px'
  },
  contentHeaderText: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text14,
    color: Colors.font.primary.darkGray,
  },
  calendarInput: {
    width: '250px',
    borderRadius: '4px',
  },
  buttonFromConfirmGradient: {
    ...Fonts.style.textHeaderKanitRegular16,
    background: 'linear-gradient(230.89deg, #7F50B2 0%, #CF1E91 100%',
    color: Colors.white,
    borderColor: Colors.lightPurple,
    height: '40px',
    width: '114px',
    borderRadius: 5
  },
  buttonFromCancelGradient: {
    ...Fonts.style.textHeaderKanitRegular16,
    background: 'transparent',
    borderColor: Colors.lightPurple,
    height: '40px',
    width: '114px',
    color: Colors.lightPurple,
    borderRadius: 5
  },
  textBoxEmail: {
    width: '300px',
  },
  asterisk: {
    width: '6px',
    height: '6px',
    marginLeft: '5px'
  },
  textBoxEmailCc: {
    width: '250px',
  }
};
